// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { 
  Bell, X, CheckCircle, AlertCircle, Info, Clock, 
  FileText, BookOpen, RotateCw, Eye, Download
} from 'lucide-react';
import './IngestionNotification.css';

const IngestionNotification = ({ notifications, onClose, onClearAll }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeNotifications, setActiveNotifications] = useState([]);

  useEffect(() => {
    setActiveNotifications(notifications.filter(n => !n.dismissed));
  }, [notifications]);

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} color="#10b981" />;
      case 'error':
        return <AlertCircle size={20} color="#ef4444" />;
      case 'warning':
        return <AlertCircle size={20} color="#f59e0b" />;
      case 'info':
        return <Info size={20} color="#8B5CF6" />;
      case 'progress':
        return <RotateCw size={20} color="#8b5cf6" className="spinning" />;
      default:
        return <Bell size={20} color="#6b7280" />;
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'success': return '#10b981';
      case 'error': return '#ef4444';
      case 'warning': return '#f59e0b';
      case 'info': return '#8B5CF6';
      case 'progress': return '#8b5cf6';
      default: return '#6b7280';
    }
  };

  const formatTime = (timestamp) => {
    const now = new Date();
    const diff = now - new Date(timestamp);
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    
    if (minutes > 0) {
      return `il y a ${minutes}m ${seconds}s`;
    }
    return `il y a ${seconds}s`;
  };

  const getStageDescription = (stage) => {
    const stageMap = {
      'RECEIVED': 'Réception du fichier',
      'FORMAT_DETECT': 'Détection du format',
      'CONVERT': 'Conversion',
      'OCR': 'Reconnaissance de texte',
      'EXTRACT': 'Extraction du contenu',
      'CLEAN': 'Nettoyage du texte',
      'SPLIT': 'Segmentation',
      'EMBEDDINGS': 'Génération d\'embeddings',
      'INDEX': 'Indexation',
      'CATALOG': 'Catalogage',
      'DONE': 'Terminé'
    };
    return stageMap[stage] || stage;
  };

  if (activeNotifications.length === 0) {
    return null;
  }

  return (
    <div className="ingestion-notification-container">
      {/* Bouton de notification */}
      <button 
        className="notification-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label={`${activeNotifications.length} notifications`}
      >
        <Bell size={20} />
        {activeNotifications.length > 0 && (
          <span className="notification-badge">
            {activeNotifications.length}
          </span>
        )}
      </button>

      {/* Panneau de notifications */}
      {isExpanded && (
        <div className="notification-panel">
          <div className="notification-header">
            <h3>Notifications d'ingestion</h3>
            <div className="notification-actions">
              <button 
                className="clear-all-btn"
                onClick={onClearAll}
                aria-label="Effacer toutes les notifications"
              >
                Effacer tout
              </button>
              <button 
                className="close-panel-btn"
                onClick={() => setIsExpanded(false)}
                aria-label="Fermer le panneau"
              >
                <X size={16} />
              </button>
            </div>
          </div>

          <div className="notification-list">
            {activeNotifications.map((notification) => (
              <div 
                key={notification.id}
                className={`notification-item notification-${notification.type}`}
                style={{ borderLeftColor: getNotificationColor(notification.type) }}
              >
                <div className="notification-icon">
                  {getNotificationIcon(notification.type)}
                </div>
                
                <div className="notification-content">
                  <div className="notification-title">
                    {notification.title}
                  </div>
                  
                  {notification.message && (
                    <div className="notification-message">
                      {notification.message}
                    </div>
                  )}
                  
                  {notification.stage && (
                    <div className="notification-stage">
                      <span className="stage-label">Étape:</span>
                      <span className="stage-name">
                        {getStageDescription(notification.stage)}
                      </span>
                    </div>
                  )}
                  
                  {notification.progress !== undefined && (
                    <div className="notification-progress">
                      <div className="progress-bar">
                        <div 
                          className="progress-fill"
                          style={{ width: `${notification.progress}%` }}
                        />
                      </div>
                      <span className="progress-text">{notification.progress}%</span>
                    </div>
                  )}
                  
                  <div className="notification-time">
                    {formatTime(notification.timestamp)}
                  </div>
                </div>
                
                <button 
                  className="dismiss-btn"
                  onClick={() => onClose(notification.id)}
                  aria-label="Fermer la notification"
                >
                  <X size={16} />
                </button>
              </div>
            ))}
          </div>

          {/* Résumé */}
          <div className="notification-summary">
            <div className="summary-stats">
              <div className="stat-item">
                <span className="stat-label">En cours:</span>
                <span className="stat-value">
                  {activeNotifications.filter(n => n.type === 'progress').length}
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Terminés:</span>
                <span className="stat-value">
                  {activeNotifications.filter(n => n.type === 'success').length}
                </span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Erreurs:</span>
                <span className="stat-value">
                  {activeNotifications.filter(n => n.type === 'error').length}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IngestionNotification;
